import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppConstants } from "src/app/app.constants";
import { AutocompleteModel } from "src/app/core/models/autocomplete.model";
import { environment } from "src/environments/environment";
import { Observable } from "rxjs";
import { User } from "src/app/core/models/user.model";

@Injectable({
	providedIn: 'root'
})
export class UsersApiService {
	private readonly root: string = `${environment.webApi}/users`;

	constructor(
		private readonly http: HttpClient,
		private readonly constants: AppConstants
	) { }

	searchUsers(searchTerm: string): Observable<AutocompleteModel[]> {
		const headers = new HttpHeaders();
		headers.append('Content-Type', 'application/json');

		let httpParams = new HttpParams().set('searchTerm', searchTerm);

		return this.http.get<AutocompleteModel[]>(`${this.root}/search`, { headers, params: httpParams });
	}

	getUserDetails(employeeId: string, includeProfilePicture: boolean = false): Observable<User> {
		return this.http.get<User>(`${this.root}/${employeeId}/details`, { params: { includeProfilePicture: includeProfilePicture } });
	}
}